import { ReactNode, useEffect } from 'react';
import { ThemeProvider } from '@pu/mpp-ui/themes';
import useTheme from 'shared/hooks/use-theme';

const ThemeContainer = ({ children }: { children: ReactNode }) => {
  const theme = useTheme();

  const { channelId, channelTheme, selectedTheme } = theme;

  useEffect(() => {
    if (channelId && channelTheme.name) {
      document.documentElement.setAttribute('data-theme', channelTheme.name); // NOSONAR
      document.title = channelTheme.title;
    }
  }, [channelId]);

  return <ThemeProvider theme={selectedTheme}>{children}</ThemeProvider>;
};

export default ThemeContainer;
